import Badge from 'components/badge/Badge';
import Switch from 'components/switch/Switch';
import { GetIntegrationAgencySettingsResponseTO } from 'models/InternalIntegrationSetting';
import NotAvailable from 'pages/integrations/components/notAvailable/NotAvailable';
import { useTranslation } from 'react-i18next';
import theme from 'styles/theme';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import {
  PropertyToggleContainerStyled,
  ToggleWithBadgeContainer,
} from '../PropertyListItem.styles';
import useToggleProperty from './useToggleProperty';

const PropertyToggle = ({
  integrationAgencySettings,
  propertyUid,
  pagePropertyUids,
  isPropertyActive,
}: {
  integrationAgencySettings: GetIntegrationAgencySettingsResponseTO;
  propertyUid: string;
  pagePropertyUids: string[];
  isPropertyActive: boolean;
}) => {
  const { t } = useTranslation();

  const {
    isIntegrationEnabled,
    isPendingStatus,
    toggleIntegration,
    isNotAvailable,
    isDisabled,
    isLoading,
  } = useToggleProperty({
    propertyUid,
    integration: integrationAgencySettings.integration,
    pagePropertyUids,
    isPropertyActive,
  });

  if (isLoading) {
    return (
      <PropertyToggleContainerStyled>
        <LoadingPlaceholder width="128px" linesCount={1.5} />
      </PropertyToggleContainerStyled>
    );
  }

  if (isNotAvailable) {
    return (
      <PropertyToggleContainerStyled>
        <NotAvailable
          integrationId={integrationAgencySettings.integration.enumId}
        />
      </PropertyToggleContainerStyled>
    );
  }

  return (
    <ToggleWithBadgeContainer>
      <Switch
        checked={isIntegrationEnabled}
        onChange={toggleIntegration}
        disabled={isDisabled}
        data-testid="property-toggle"
      />
      {isPendingStatus && (
        <Badge
          backgroundColor={theme.colors.hostfullyYellow}
          data-testid="pending-status"
        >
          {t('pageIntegrations.integrationDetails.pending')}
        </Badge>
      )}
    </ToggleWithBadgeContainer>
  );
};

export default PropertyToggle;
